import Api from "@/services/Index";

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/esl/change-of-class/requests", config);
};

const get = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/esl/change-of-class/requests/" + id);
};

const getForm = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/esl/change-of-class/requests/form");
};

const store = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/esl/change-of-class/requests", data);
};
const update = async (id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put("/esl/change-of-class/requests/" + id, formData);
};
const studentFormRequest = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/esl/change-of-class/requests/form");
};
const exportExcel = (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/esl/change-of-class/requests/excel-export', {...config, responseType: 'arraybuffer'});
}
export default {
    getAll,
    update,
    get,
    getForm,
    store,
    studentFormRequest,
    exportExcel
};
